import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  stepper: {
    maxWidth: 700,
    margin: '0 auto',
    paddingBottom: theme.spacing(1.5),
  },
}));
